import React from 'react';

import { eyeOpen, replyArrow } from '@/assets/icons';
import { SvgIcon } from '@material-ui/core';

import styles from './MessageHeader.module.scss';

export interface MessageHeaderProps {
	isReply?: boolean;
	isPrivate?: boolean;
	content: string;
}

export const MessageHeader = ({
	isReply,
	isPrivate,
	content,
}: MessageHeaderProps) => {
	let leadingIcon;

	if (isPrivate) {
		leadingIcon = (
			<SvgIcon
				className={styles['header__leading-icon']}
				component={eyeOpen}
			/>
		);
	} else if (isReply) {
		leadingIcon = (
			<SvgIcon
				className={styles['header__leading-icon']}
				component={replyArrow}
			/>
		);
	}

	return (
		<div className={styles['header']}>
			{leadingIcon}
			{content}
			{isPrivate && ` (Only visible to you)`}
		</div>
	);
};
